import { render, staticRenderFns } from "./modalAgendaEdit.vue?vue&type=template&id=3304f6fa&scoped=true"
import script from "./modalAgendaEdit.vue?vue&type=script&lang=js"
export * from "./modalAgendaEdit.vue?vue&type=script&lang=js"
import style0 from "./modalAgendaEdit.vue?vue&type=style&index=0&id=3304f6fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3304f6fa",
  null
  
)

export default component.exports